import { createClient, setupInterceptors } from "@workspace/shared";
import { store, persistor } from "../redux/store";
import { updateAuthData } from "../redux/function";
import { clearAuthData } from "../redux/slices/authSlice";
import { ROUTES } from "./routes";
import { API_ENDPOINTS } from "./endpoint";
import { AuthState } from "@/types/auth";

export const AuthClient = createClient(import.meta.env.VITE_API_BASE_URL);
export const ApiClient = createClient(import.meta.env.VITE_API_BASE_URL);

setupInterceptors<AuthState>(ApiClient, AuthClient, {
  store,
  persistor,
  routes: {
    LOGIN: ROUTES.LOGIN.BASE,
    PRICING: "",
  },
  endpoints: {
    REFRESH_TOKEN: API_ENDPOINTS.AUTH.REFRESH_TOKEN,
  },
  onAuthUpdate: updateAuthData,
  onAuthClear: () => store.dispatch(clearAuthData()),
});
